/*
 * SMParts — Bike-Blatt
 *
 * Oeffnet und schliesst die flache Lade mit dem Bike-Waehler und haelt
 * den Haken am Symbol in der Kopfzeile aktuell.
 *
 * Der Waehler selbst bleibt unangetastet. Aufgeklappt wird er ueber
 * seinen eigenen Einstiegsknopf — ein Klick per JavaScript wirkt auch
 * auf ein per CSS verstecktes Element. So gibt es keine zweite
 * Steuerung, die mit der ersten aus dem Takt geraten kann.
 *
 * Die Scroll-Sperre laeuft absichtlich ueber eine eigene Klasse
 * (smp-blatt-offen) und nicht ueber Dawns overflow-hidden-tablet:
 * sonst wuerden sich Drawer und Lade gegenseitig die Sperre wegnehmen.
 */
(function () {
  'use strict';

  var SPEICHER = 'smp:bike';
  var GEAENDERT = 'smp:bike-changed';

  function bikeGesetzt() {
    try {
      var roh = window.localStorage.getItem(SPEICHER);
      var b = roh ? JSON.parse(roh) : null;
      return !!(b && b.marke);
    } catch (e) {
      return false;
    }
  }

  function bikeName() {
    try {
      var b = JSON.parse(window.localStorage.getItem(SPEICHER) || 'null');
      if (!b || !b.marke) return '';
      return [b.marke, b.modell, b.baujahr].filter(Boolean).join(' · ');
    } catch (e) {
      return '';
    }
  }

  function hakenPflegen() {
    var gesetzt = bikeGesetzt();
    var name = bikeName();
    document.querySelectorAll('[data-smp-bike-name]').forEach(function (n) {
      n.textContent = name || 'Bike wählen';
    });
    document.querySelectorAll('[data-smp-bike-haken]').forEach(function (h) {
      h.hidden = !gesetzt;
    });
    document.querySelectorAll('[data-smp-bike-knopf]').forEach(function (k) {
      k.setAttribute(
        'aria-label',
        gesetzt ? 'Dein Bike ändern' : 'Dein Bike wählen'
      );
    });
  }

  function start() {
    hakenPflegen();

    var blatt = document.querySelector('[data-smp-bike-blatt]');
    var knopf = document.querySelector('[data-smp-bike-knopf]');
    if (!blatt || !knopf || blatt.smpBereit) return;
    blatt.smpBereit = true;

    var waehler = blatt.querySelector('[data-smp-bike]');

    function auf() {
      blatt.hidden = false;
      /*
       * Ein Bild weiter warten, sonst startet der Uebergang aus dem
       * Endzustand und die Lade erscheint ohne Bewegung.
       */
      window.requestAnimationFrame(function () {
        blatt.classList.add('smp-bikeblatt--offen');
      });
      document.body.classList.add('smp-blatt-offen');
      knopf.setAttribute('aria-expanded', 'true');

      /* Den Waehler aufklappen, falls er noch zu ist. */
      if (waehler && !waehler.classList.contains('smp-bike--offen')) {
        var oeffner =
          waehler.querySelector('[data-smp-bike-change]') ||
          waehler.querySelector('[data-smp-bike-start]');
        if (oeffner) oeffner.click();
      }
    }

    function zu() {
      blatt.classList.remove('smp-bikeblatt--offen');
      document.body.classList.remove('smp-blatt-offen');
      knopf.setAttribute('aria-expanded', 'false');

      /*
       * Erst nach dem Uebergang verstecken, sonst verschwindet die Lade
       * ohne Bewegung. Die Frist liegt bewusst ueber der Dauer im
       * Stylesheet (0.26s) — und weil hidden am Ende auf jeden Fall
       * gesetzt wird, bleibt nichts haengen, wenn der Uebergang
       * ausfaellt (Tab im Hintergrund, reduzierte Bewegung).
       */
      window.setTimeout(function () {
        if (!blatt.classList.contains('smp-bikeblatt--offen')) blatt.hidden = true;
      }, 320);
    }

    knopf.addEventListener('click', function () {
      if (blatt.hidden) auf();
      else zu();
    });

    /*
     * Jede andere Stelle der Seite kann die Lade oeffnen, indem sie
     * data-smp-bike-oeffner traegt — die Passform-Zeile auf der
     * Produktseite tut das.
     *
     * Delegiert und nicht je Element gebunden: die Passform-Zeile
     * zeichnet ihre Knoepfe erst neu, wenn der Zustand wechselt, und
     * einzeln gebundene Zuhoerer waeren danach weg.
     */
    document.addEventListener('click', function (e) {
      var ziel = e.target.closest && e.target.closest('[data-smp-bike-oeffner]');
      if (!ziel) return;
      e.preventDefault();
      if (blatt.hidden) auf();
    });

    blatt.querySelectorAll('[data-smp-bike-blatt-zu]').forEach(function (b) {
      b.addEventListener('click', zu);
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && !blatt.hidden) zu();
    });

    /*
     * Jede Aenderung schliesst die Lade — gewaehlt wie entfernt.
     *
     * Beim Entfernen ist das wichtiger als es klingt: der Waehler
     * klappt danach seine Auswahl zu, uebrig bliebe eine leere Lade mit
     * nur der Ueberschrift. Das sieht aus wie ein Fehler. Zu und fertig
     * — neu waehlen geht ueber das Symbol oben rechts.
     */
    document.addEventListener(GEAENDERT, function () {
      hakenPflegen();
      if (!blatt.hidden) window.setTimeout(zu, 220);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Im Theme-Editor wird die Kopfzeile neu gezeichnet. */
  document.addEventListener('shopify:section:load', start);
  document.addEventListener(GEAENDERT, hakenPflegen);
})();
